import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import { SlideDown } from 'react-slidedown'
import analytics from '../../helpers/analytics'
import config from 'config'
import {
  Link,
  LinkIcon
} from '../'
import Styles from './AmazonStaffLetters.css'


@CSSModules(Styles,{allowMultiple:true})
export default class AmazonStaffPeerLetter extends Component {
  constructor(props) {
    super(props)

    const letterTo = ''
    const letterSubject = 'Amazon 401(k) sustainability'
    const letterText = `
Dear [colleague],

I just found out my 401(k) investments are funding fossil fuels and companies that are burning down the Amazon rainforest.

It looks like most of us at Amazon are in the same boat - over 50% of the plan’s assets are in the default option, which invests in fossil fuels, deforestation, arms manufacturers, and companies that score poorly on gender equality.

The data on the Amazon.com 401(k) can be found here:
https://investyourvalues.org/retirement-plans/amazon-com

I care about these issues and do not want my retirement savings to support companies that are destroying the environment and fueling social inequality.

Unfortunately, we only have one sustainable investment option in the plan, and less than 2% of plan assets are invested in this option.

We’ve taken a lot of positive steps as a company to protect the environment, but we need to have more sustainable and climate-friendly investment options if we want to continue to make a collective difference at Amazon.

If you want to learn what’s inside the 401(k) options at Amazon, you can visit the URL above.

We all have the power to support an economy that is based on justice and sustainably through our retirement investments.

Thank you for taking the time to listen, and look forward to hearing from you soon.

Sincerely,
    `

    const emailHref = `mailto:${letterTo}?subject=${encodeURIComponent(letterSubject)}&body=${encodeURIComponent(letterText)}`

    this.state = {
      showPeerLetter: false,
      emailHref
    }
  }

  render() {
    const { showPeerLetter, emailHref } = this.state
    //
    return (
      <div styleName='letter-box'>
        <div styleName='letter-box-flex'>
          <div styleName='letter-box-label'>
            <h2>
              Send a message to your peers
            </h2>
            <p>
              Send a message to your coworkers and colleagues asking them to
              join in asking Amazon management for a sustainable 401(k).
            </p>
            <p>
              <button
                styleName='show-letter-button'
                onClick={
                  () => {
                    this.setState(
                      { showPeerLetter: !showPeerLetter }
                    )
                  }
                }
              >
                Letter to peers<LinkIcon
                  faclass={
                    showPeerLetter ?
                      'fa-angle-double-up' :
                      'fa-angle-double-down'
                  }
                />
              </button>
            </p>
          </div>
          <div styleName='take-action-icons'>
            <div>
              <Link
                to={emailHref}
                title='Send a message to your colleagues'
                log={analytics.eventStaffSupport('Amazon','peer_message')}
                targetBlank
              >
                <div>
                  <p>
                    Email
                  </p>
                  <div>
                    <LinkIcon nospace faclass='fa-envelope'/>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
        <SlideDown>
          {
            showPeerLetter ?
              (
                <blockquote styleName='company-letter-blockquote'>
                  <p>Dear <b>[colleague],</b></p>

                  <p>I just found out my 401(k) investments are funding fossil fuels and companies that are burning down the Amazon rainforest.</p>

                  <p>It looks like most of us at Amazon are in the same boat - over 50% of the plan’s assets are in the default option, which invests in fossil fuels, deforestation, arms manufacturers, and companies that score poorly on gender equality.</p>

                  <p>The data on the Amazon.com 401(k) can be found here:<br/>
                  <Link
                  to={config.routes.plans + '/amazon-com'}
                  title='Amazon.com retirement plan sustainability scorecard'
                  xstrong
                  >https://investyourvalues.org/retirement-plans/amazon-com</Link></p>

                  <p>I care about these issues and do not want my retirement savings to support companies that are destroying the environment and fueling social inequality.</p>

                  <p>Unfortunately, we only have one sustainable investment option in the plan, and less than 2% of plan assets are invested in this option.</p>

                  <p>We’ve taken a lot of positive steps as a company to protect the environment, but we need to have more sustainable and climate-friendly investment options if we want to continue to make a collective difference at Amazon. </p>

                  <p>If you want to learn what’s inside the 401(k) options at Amazon, you can visit the URL above. </p>

                  <p>We all have the power to support an economy that is based on justice and sustainably through our retirement investments. </p>

                  <p>Thank you for taking the time to listen, and look forward to hearing from you soon.</p>

                  <p>Sincerely,<br/>
                  <b>[Your Name]<br/>
                  [Your contact information: company department, email, phone, etc.]</b></p>
                </blockquote>
              ) :
              null
          }
        </SlideDown>
      </div>
    )
  }
}
